import {
    createApi,
    fetchBaseQuery,
} from '@reduxjs/toolkit/query/react'
import {v4 as uuidv4} from 'uuid'

const baseQuery = fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_SERVER_URL,
    prepareHeaders: (headers, {getState}) => {
        const token = getState().login.accessToken
        const anonymousId = headers.get('anonymous-user-id')
        headers.set('platform-name', 'WEB')
        headers.set('build-number', '1')
        headers.set('Client-Id', process.env.REACT_APP_CLIENT_ID)
        // headers.set('time-zone', 'Asia/Kolkata')
        if (token) {
            headers.set('authorization', `Bearer ${token}`)
        }
        if (!anonymousId) {
            let id = localStorage.getItem('tp-id')
            if (!id) {
                id = uuidv4()
                headers.set('anonymous-user-id', id)
                localStorage.setItem('tp-id', id)
            } else {
                headers.set('anonymous-user-id', id)
            }
        }
        return headers
    },
})

export const apiSlice = createApi({
    baseQuery: baseQuery,
    endpoints: builder => ({}),
})
